import React from "react";
import { AddToGoogleCalendar } from "../ThemeOne/components/AddToGoogleCalendar";
import Footer from "../ThemeOne/components/Footer";
import { WishesSession } from "../ThemeOne/components/WishesSession";
import { YouTubeEmbed } from "../ThemeOne/components/YouTubeEmbed";
import GridGallery from "./components/GridGallery";
import SecondSession from "./components/SecondSession";
import ThirdSession from "./components/ThirdSession";
import TopSession from "./components/TopSession";

export default function ThemeTwo({ data }) {
  return (
    <div style={{ backgroundColor: data.bgColor }}>
      <div
        style={{ backgroundColor: data.bgColor }}
        className="w-full flex justify-center"
      >
        <div style={{ backgroundColor: data.bgColor }} className="max-w-7xl">
          <TopSession data={data} />
          <SecondSession data={data} />
          <ThirdSession data={data} />
          {data.addYouTube && (
            <YouTubeEmbed url={data.youTubeLink} flower={data.flower} />
          )}
          <WishesSession data={data} />
          <GridGallery images={data.images} />
          <AddToGoogleCalendar data={data} />
          <Footer />
        </div>
      </div>
    </div>
  );
}
